import { render, staticRenderFns } from "./SlideShowAdd.vue?vue&type=template&id=2d8a50c0&scoped=true&"
import script from "./SlideShowAdd.vue?vue&type=script&lang=js&"
export * from "./SlideShowAdd.vue?vue&type=script&lang=js&"
import style0 from "./SlideShowAdd.vue?vue&type=style&index=0&id=2d8a50c0&scoped=true&lang=css&"
import style1 from "./SlideShowAdd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8a50c0",
  null
  
)

export default component.exports